module.exports = __webpack_public_path__ + "img/36_80.c9e08e7f.png";